Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var cn = require('classnames');
var coreComponentsButton = require('../button');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var styles = {"customButton":"custom-button__customButton_12uz8","border":"custom-button__border_12uz8","white":"custom-button__white_12uz8","black":"custom-button__black_12uz8","static-white":"custom-button__static-white_12uz8","static-black":"custom-button__static-black_12uz8","darkening":"custom-button__darkening_12uz8","lightening":"custom-button__lightening_12uz8","static-darkening":"custom-button__static-darkening_12uz8","static-lightening":"custom-button__static-lightening_12uz8","customLoading":"custom-button__customLoading_12uz8"};
require('./index.css');

var DEFAULT_BUTTON_COLOR = '#FF45C3';
var DEFAULT_CONTENT_COLOR = 'white';
var CustomButton = React__default.default.forwardRef(function (_a, ref) {
    var _b;
    var children = _a.children, className = _a.className, loading = _a.loading, _c = _a.backgroundColor, backgroundColor = _c === void 0 ? DEFAULT_BUTTON_COLOR : _c, _d = _a.contentColor, contentColor = _d === void 0 ? DEFAULT_CONTENT_COLOR : _d, _e = _a.stateType, stateType = _e === void 0 ? 'darkening' : _e, restProps = tslib.__rest(_a, ["children", "className", "loading", "backgroundColor", "contentColor", "stateType"]);
    var buttonProps = tslib.__assign({ style: { background: backgroundColor } }, restProps);
    var buttonClassName = cn__default.default(styles.customButton, styles.border, className, styles[contentColor], styles[stateType], (_b = {},
        _b[styles.customLoading] = loading,
        _b));
    return (React__default.default.createElement(coreComponentsButton.Button, tslib.__assign({}, buttonProps, { view: 'primary', ref: ref, className: buttonClassName, loading: loading }), children));
});
CustomButton.displayName = 'CustomButton';

exports.CustomButton = CustomButton;
